module.exports = "<svg id=\"9c32fb44-e030-4ac6-a85b-95a17a0e9411\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>smile</title><path d=\"M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm6.37,15.19a2.94,2.94,0,1,1-2.94,2.94h0A3,3,0,0,1,31.37,15.19Zm-12.76,0a2.94,2.94,0,1,1-2.94,2.94,2.94,2.94,0,0,1,2.94-2.94h0ZM37.49,33.42a12.69,12.69,0,0,1-25,0l-.1-.58H37.6Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/smile.svg
// module id = 585
// module chunks = 1